import React, { Fragment } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Placeholder } from "react-bootstrap";
import { DEFAULT_IMAGE_SRC, SECTION_ITEM_TYPE } from "@constants";
import { NoData, TabContent } from "@components";
import { AboutTab, ReviewsTab } from "@pages";
import { VideoPlayer } from "./VideoPlayer";
import { Quiz } from "./Quiz";
import { Assignment } from "./Assignment";
import styles from "./styles/Content.module.css";

const Content = (props) => {
  const {
    lesson,
    processing,
    courseId,
    courseInfo,
    hasPrev,
    handlePrevious,
    hasNext,
    handleNext,
  } = props;

  const tabInfoList = [
    {
      id: "overview-tab",
      title: "Overview",
      content: (
        <AboutTab
          requirements={courseInfo?.requirement}
          description={courseInfo?.description}
          benefits={courseInfo?.learn}
        />
      ),
    },
    {
      id: "reviews-tab",
      title: "Reviews",
      content: (
        <ReviewsTab
          courseId={courseId}
          author={courseInfo?.user}
          loadReviews={courseInfo ? true : false}
        />
      ),
    },
  ];

  if (processing) {
    return (
      <Placeholder animation="glow">
        <div className="col">
          <img
            src={DEFAULT_IMAGE_SRC}
            width="100%"
            height="350px"
            className={clsx("placeholder", styles.video)}
          />
        </div>
        <div className="col mt-4">
          <Placeholder xs={5} />
          <Placeholder xs={11} />
          <Placeholder xs={9} />
        </div>
        <div className="col mt-4">
          <Placeholder size="lg" xs={12} as="h3" />
        </div>
      </Placeholder>
    );
  }

  if (!lesson) {
    return (
      <Fragment>
        <NoData
          className="border-0 bg-transparent"
          message="Select a lecture"
        />
        <TabContent
          data={tabInfoList}
          navClassName={styles.navContainer}
          topContent={null}
          isAlignCenter={false}
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className={styles.mainContentContainer}>
        <div className={styles.btnRedirectWrapper}>
          {hasPrev && (
            <button className={styles.btnPrev} onClick={handlePrevious}>
              <i className="bi bi-chevron-compact-left"></i>
            </button>
          )}
          {hasNext && (
            <button className={styles.btnNext} onClick={handleNext}>
              <i className="bi bi-chevron-compact-right"></i>
            </button>
          )}
        </div>

        <div className={styles.mainContent}>
          {lesson.type === SECTION_ITEM_TYPE.LECTURE && (
            <VideoPlayer
              data={lesson}
              hasNext={hasNext}
              handleNext={handleNext}
            />
          )}
          {lesson.type === SECTION_ITEM_TYPE.QUIZ && (
            <Quiz data={lesson} hasNext={hasNext} handleNext={handleNext} />
          )}
          {lesson.type === SECTION_ITEM_TYPE.ASSIGNMENT && (
            <Assignment
              data={lesson}
              hasNext={hasNext}
              handleNext={handleNext}
            />
          )}
        </div>
      </div>

      <TabContent
        data={tabInfoList}
        navClassName={styles.navContainer}
        isAlignCenter={false}
      />
    </Fragment>
  );
};

/* required: display name */
Content.displayName = "Content";

/* required: props types */
Content.propTypes = {
  courseInfo: PropTypes.object,
  lesson: PropTypes.object,
  processing: PropTypes.bool,
  courseId: PropTypes.string,
};

/* required: default props */
Content.defaultProps = {
  courseInfo: null,
  lesson: null,
  processing: false,
  courseId: "",
};

export { Content };
